/* eslint-disable no-console */
const list = type => {
  const plg = window.leveregePlugin?.library?.Plugins?.types;
  if (type == null) {
    console.log('Plugins');
    console.log(plg);
    return plg;
  }
  console.log(type, 'Plugins');
  console.log(plg[type]);
  return plg[type];
};
const instance = window.leveregePlugin?.library?.Plugins;
export default {
  list,
  instance
};